/**
 * Main App Component - Cloudflare Browser Container Integration
 * Master-level architecture with complete production features
 */

import { SessionOrchestratorProvider } from './contexts/SessionOrchestrator';
import MultiSessionDashboard from './components/MultiSessionDashboard';

function App() {
  return (
    <SessionOrchestratorProvider
      maxConcurrentSessions={5}
      autoHibernate={true}
      hibernateAfterMs={300000}
      enableRecording={true}
      enableSync={true}
    >
      <div className="min-h-screen bg-ocean-deep">
        {/* Header */}
        <header className="bg-ocean-muted border-b border-ocean-cyan/20 px-6 py-4">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-ocean-cyan to-ocean-green rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-ocean-deep" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <div>
                <h1 className="text-xl font-bold text-ocean-cyan">
                  Cloudflare Browser Containers
                </h1>
                <p className="text-xs text-ocean-cyan/60">
                  Edge-powered browser streaming with React
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-ocean-green rounded-full animate-pulse" />
                <span className="text-sm text-ocean-cyan">Connected to Edge</span>
              </div>
              <a
                href="https://github.com/cloudflare/workers-sdk"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 hover:bg-ocean-cyan/20 rounded-lg transition-colors"
              >
                <svg className="w-5 h-5 text-ocean-cyan" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1">
          <MultiSessionDashboard />
        </main>

        {/* Footer Status Bar */}
        <footer className="bg-ocean-muted border-t border-ocean-cyan/20 px-6 py-2">
          <div className="max-w-7xl mx-auto flex items-center justify-between text-xs text-ocean-cyan/60">
            <div className="flex items-center space-x-4">
              <span>Powered by Cloudflare Workers</span>
              <span>•</span>
              <span>noVNC v1.4.0</span>
              <span>•</span>
              <span>React 18.3</span>
            </div>
            <div className="flex items-center space-x-4">
              <span>Edge Location: Auto</span>
              <span>•</span>
              <span>Latency: &lt;50ms</span>
            </div>
          </div>
        </footer>
      </div>
    </SessionOrchestratorProvider>
  );
}

export default App;